<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12>
				<app-datatable
					:title="$t('title.holidays_datatable')"
					:endpoint="endpoint"
					:data="data"
					:headers="headers"
					@onEdit="editItem"
					@onDelete="deleteItem"
					@onView="viewItem"
				>
					<template v-slot:[`item.active`]="{ item }">
						<app-active-button
							v-model="item.active"
						></app-active-button>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>

		<app-create-fab-button
			@click="
				$inertia.visit(
					$route('tenant.holidays.create', {
						tenant: $page.props.tenant.id,
					})
				)
			"
		></app-create-fab-button>
	</v-container>
</template>

<script>
export default {
	props: ["data"],
	data() {
		return {
			items: this.data.data,
		};
	},
	computed: {
		endpoint() {
			return this.$route("tenant.holidays.index", {
				tenant: this.$page.props.tenant.id,
			});
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					sortable: false,
					searchable: false,
					align: "left",
					width: 80,
				},
				{
					text: this.$t("Name"),
					value: "name",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("label.date_start"),
					value: "date_start",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("label.date_end"),
					value: "date_end",
					sortable: false,
					searchable: false,
					width: 200,
				},
				{
					text: this.$t("Time"),
					value: "time",
					sortable: false,
					searchable: false,
					width: 200,
				},
				{
					text: this.$t("Active"),
					value: "active",
					sortable: false,
					searchable: false,
					width: 150,
					align: "right",
				},
			];
		},
	},

	methods: {
		editItem(item) {
			this.$inertia.get(
				this.$route("tenant.holidays.edit", {
					tenant: this.$page.props.tenant.id,
					holiday: item.uuid,
				})
			);
		},

		viewItem(item) {
			this.$inertia.get(
				this.$route("tenant.holidays.show", {
					tenant: this.$page.props.tenant.id,
					holiday: item.uuid,
				})
			);
		},

		deleteItem() {
			//
		},
	},
};
</script>